export default __webpack_public_path__ + "static/media/diamond-card.061fe201.svg";